/**
 * @desc 新增
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(body: defs.esca.EChapterRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/eChapter/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
